import { tryParseLoanEventFromApi } from "./events-parser";
import { ApiLoanDetail, ApiLoanSummary, ApiLoanSummaryItem } from "../api";
import { LoanInfo, LoanInfoResponse } from "../domain";

export function parseApiLoanSummary(response: ApiLoanSummary): LoanInfoResponse {
    return {
        ...response,
        items: response.items.map(parseApiLoanSummaryItem)
    };
}

export function parseApiLoanDetail(loanInfo: ApiLoanDetail): LoanInfo {
    return {
        ...loanInfo,
        events: loanInfo.events.flatMap((event) => {
            const parsedEvent = tryParseLoanEventFromApi(event);
            return parsedEvent ? [parsedEvent] : [];
        })
    };
}

function parseApiLoanSummaryItem(loanInfo: ApiLoanSummaryItem): LoanInfo {
    return {
        ...loanInfo,
        pastLedgers: [],
        matrixUpdates: [],
        events: []
    };
}
